


































































import { computed, defineComponent } from '@nuxtjs/composition-api'
import IconFaSolidLeft from '~icons/fa-solid/caret-left'
import IconFaSolidRight from '~icons/fa-solid/caret-right'

export default defineComponent({
  components: {
    IconFaSolidLeft,
    IconFaSolidRight,
  },
  props: {
    pageSizes: {
      type: Array as () => number[],
      default: () => [5, 15, 25, 50],
    },
    currentPage: {
      type: Number,
      required: true,
    },
    currentPageSize: {
      type: Number,
      required: true,
    },
    totalCitations: {
      type: Number,
      required: true,
    },
  },
  emits: ['currentPageChange', 'currentSizeChange'],
  setup(props, { emit }) {
    const scrollCitation = () => {
      document.querySelector('#top-of-citations')?.scrollIntoView({ behavior: 'smooth' })
    }
    const totalPages = computed(() => Math.ceil(props.totalCitations / props.currentPageSize))
    const changePageSize = (e: Event) => {
      const target = e.target as HTMLSelectElement
      emit('currentSizeChange', parseInt(target.value))
    }
    return {
      changePageSize,
      totalPages,
      scrollCitation,
    }
  },
})
